import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { logout } from '../services/api';

export default function Navbar() {
  const { user, logoutUser, isSuperAdmin, isAdminOrAbove } = useAuth();
  const { pathname } = useLocation();
  const navigate     = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);

  const handleLogout = async () => {
    try { await logout(); } catch {}
    logoutUser();
    navigate('/login');
  };

  // ── Role badge color ─────────────────────────────────────
  const roleBadge = {
    1: { label: 'Super Admin',  css: 'bg-yellow-100 text-yellow-700' },
    2: { label: 'Admin',        css: 'bg-blue-100 text-blue-700'     },
    3: { label: 'Teacher',      css: 'bg-green-100 text-green-700'   },
  }[user?.role_id] || { label: user?.role_name, css: 'bg-gray-100 text-gray-600' };

  // ── Nav links based on role ──────────────────────────────
 const links = [
  { to: '/',             label: 'ප්‍රධාන',       show: true              },
  { to: '/maintenance',  label: 'නඩත්තු වාර්තා', show: true              },
  { to: '/schools',      label: 'පාසල්',          show: isAdminOrAbove    },
  { to: '/employees',    label: 'නිලධාරීන්',      show: isAdminOrAbove    },
  { to: '/users',        label: 'පරිශීලකයන්',     show: isSuperAdmin      },
  { to: '/activity-log', label: 'Activity Log',  show: isSuperAdmin      },
].filter(l => l.show);

  return (
    <nav className="bg-red-600 shadow-lg sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4">
        <div className="flex items-center justify-between h-16">

          {/* ── Logo ── */}
          <div className="flex items-center gap-3">
            <div className="bg-white rounded-lg p-1.5">
              <svg className="w-5 h-5 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
                  d="M9 3H5a2 2 0 00-2 2v4m6-6h10a2 2 0 012 2v4M9 3v18m0 0h10a2 2 0 002-2V9M9 21H5a2 2 0 01-2-2V9m0 0h18"/>
              </svg>
            </div>
            <span className="text-white font-bold text-base hidden sm:block">
              දෘඩාංග නඩත්තු
            </span>
          </div>

          {/* ── Desktop Links ── */}
          <div className="hidden md:flex items-center gap-1">
            {links.map(({ to, label }) => (
              <Link key={to} to={to}
                className={`px-3 py-2 rounded-lg text-sm font-medium transition-colors ${
                  pathname === to
                    ? 'bg-white text-red-600'
                    : 'text-red-100 hover:bg-red-500 hover:text-white'
                }`}>
                {label}
              </Link>
            ))}
          </div>

          {/* ── User Info + Logout ── */}
          <div className="hidden md:flex items-center gap-3">
            <div className="text-right">
              <p className="text-white text-sm font-medium leading-none">{user?.name}</p>
              <span className={`text-xs px-2 py-0.5 rounded-full font-medium mt-1 inline-block ${roleBadge.css}`}>
                {roleBadge.label}
              </span>
            </div>
            <button onClick={handleLogout}
              className="bg-white/20 hover:bg-white/30 text-white px-3 py-1.5 rounded-lg text-sm transition">
              ඉවත් වන්න
            </button>
          </div>

          {/* ── Mobile Menu Button ── */}
          <button onClick={() => setMenuOpen(!menuOpen)}
            className="md:hidden text-white p-2">
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              {menuOpen
                ? <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12"/>
                : <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16"/>
              }
            </svg>
          </button>

        </div>
      </div>

      {/* ── Mobile Menu ── */}
      {menuOpen && (
        <div className="md:hidden bg-red-700 px-4 pb-4 space-y-1">
          {links.map(({ to, label }) => (
            <Link key={to} to={to}
              onClick={() => setMenuOpen(false)}
              className={`block px-3 py-2 rounded-lg text-sm font-medium ${
                pathname === to ? 'bg-white text-red-600' : 'text-red-100 hover:bg-red-600'
              }`}>
              {label}
            </Link>
          ))}
          <div className="border-t border-red-600 pt-3 mt-3">
            <p className="text-red-200 text-xs mb-1">{user?.name}</p>
            <button onClick={handleLogout}
              className="w-full text-left text-red-100 hover:text-white text-sm py-1">
              ඉවත් වන්න →
            </button>
          </div>
        </div>
      )}
    </nav>
  );
}